import React from "react";
import { X } from "react-feather";
import Modal from "react-modal";
import theme from "../../../Styles/theme";
import { Container, DivX, Message, Title } from "./styles";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",

    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
    open: boolean;
    onClose(): void;
    title: string;
    message: string;
  }
  
 
export function Alert({ open, onClose, title, message }: Props) {
  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <Container>
        <DivX>
          <X
            onClick={onClose}
            style={{ cursor: "pointer" }}
            color={theme.colors.dark}
            size={"max(0.6vw +  6px)"}
          />
        </DivX>
        <Title>{title}</Title>
        <Message>{message}</Message>
      </Container>
    </Modal>
  );
}